// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"flip-to-back"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M4 8.5V20H15.5","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M9.5 16H8V14.5M13.5 16H14.5M18.5 4H20V5.5M20 9.5V10.5M18.5 16H20V14.5M8 9.5V10.5M9.5 4H8V5.5M13.5 4H14.5","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-flip-to-back')
export default class FlipToBackIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'flip-to-back',
    }
  }
}
